module.exports = __webpack_public_path__ + "img/audio-blue.6703675f.png";